// extracted by mini-css-extract-plugin
export var darkMode = "_l-0";